import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { TooltipHeader as c } from "./TooltipHeader.js";
import { TooltipFooter as e } from "./TooltipFooter.js";
const j = a(
  ({ step: p, position: d, onClose: i, onPrevious: f, onNext: l, totalSteps: r, stepNumber: o }, m) => /* @__PURE__ */ s(
    "div",
    {
      ref: m,
      id: "tour-tooltip",
      "data-testid": "tour-tooltip",
      style: {
        top: `${d.top}px`
      },
      children: [
        /* @__PURE__ */ t(
          c,
          {
            stepNumber: o,
            totalSteps: r,
            onClose: i
          }
        ),
        /* @__PURE__ */ t("p", { children: p.content }),
        /* @__PURE__ */ t(
          e,
          {
            stepNumber: o,
            isFirstStep: o === 1,
            isLastStep: o === r,
            onClose: i,
            onPrevious: f,
            onNext: l
          }
        )
      ]
    }
  )
);
export {
  j as TourTooltip
};
